import MedalCard     from '../components/MedalCard';
import useScrollReveal from '../hooks/useScrollReveal';

import loveSvg   from '../assets/images/love.svg';
import goldSvg   from '../assets/images/gold.svg';
import silverSvg from '../assets/images/silver.svg';
import bronzeSvg from '../assets/images/bronze.svg';

const MEDALS = [
  { imageSrc: goldSvg,   name: 'Gold',   color: '#FFD700', condition: 'Finish in ≤ par taps',     delay: 0   },
  { imageSrc: silverSvg, name: 'Silver', color: '#C0C0C0', condition: 'Finish in ≤ par + 3 taps', delay: 120 },
  { imageSrc: bronzeSvg, name: 'Bronze', color: '#CD7F32', condition: 'Any finish — you solved it!', delay: 240 },
];

export default function Medals() {
  const [ref, visible] = useScrollReveal();

  return (
    <section className="section">
      <div className="container section-content">

        <div ref={ref} className={`reveal ${visible ? 'visible' : ''}`}>
          <div className="medals-header">
            <div>
              <h2 className="section-headline">How well did you do?</h2>
              <p className="section-sub" style={{ marginTop: 8 }}>
                Every solved puzzle earns a medal. Chase gold for the perfect run.
              </p>
            </div>
            <img src={loveSvg} alt="Love mascot" />
          </div>
        </div>

        <div className="medals-grid">
          {MEDALS.map(medal => (
            <MedalCard key={medal.name} {...medal} />
          ))}
        </div>

      </div>
    </section>
  );
}
